import {
  Divider,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { FaStore } from 'react-icons/fa';
import { FiMoreVertical } from 'react-icons/fi';
import { MdArrowDropDown, MdArrowDropUp, MdAttachMoney, MdMoneyOff, MdTimer } from 'react-icons/md';
import { SiIfood } from 'react-icons/si';

import { useAuth } from '../../../hooks/auth';

type SortData = {
  por: string;
  cres: boolean;
};
type ControlsData = {
  page: number;
  perPage: number;
  totalPage: number;
};
type TotalsData = {
	custo: string;
	entrega: string;
	troco: string;
};
type EntregaData = {
	id_entrega: number;
	id_loja: number;
	id_venda: number;
	id_entregador: number;
	nome_entregador: string;
	nome_cliente: string;
	tipo_venda: string;
	data_venda: string;
	data_entrega: string;
	data_previsao: string;
	atraso: string;
	tempo: string;
	obs_entrega: string;
	pago: string;
	evento: string;
	motivo: string;
	vlr_custo: number;
	vlr_entrega: number;
	vlr_troco: number;
	vlr_total: number;
	vlr_custoFormatted: string;
	vlr_entregaFormatted: string;
	vlr_trocoFormatted: string;
	vlr_totalFormatted: string;
};
interface DataTableTableParams {
  entregas: EntregaData[];
  pesqEntregas: EntregaData[];
	totals: TotalsData;
  sort: SortData;
  setSort: (sort: SortData) => void;
  controls: ControlsData;
  handleUpdateList: (
    page: number,
    perPage: number,
    entregas: EntregaData[],
  ) => void;
	setEntregaModal: (entrega: EntregaData) => void;
	setModalEntregaVisible: (visible: boolean) => void;
}

const DataTableTable: React.FC<DataTableTableParams> = ({
	entregas,
	pesqEntregas,
	totals,
  sort,
  setSort,
  controls,
  handleUpdateList,
	setEntregaModal,
	setModalEntregaVisible
}) => {
	const { permissions } = useAuth();

  function handleSort(prop: string) {
    let mapped: EntregaData[] = [];

    const auxCres = !sort.cres;

    if (sort.por === prop) {
      if (auxCres) {
        mapped = pesqEntregas.sort((a, b) => {
          return (
            +(Object(a)[prop] > Object(b)[prop]) ||
            +(Object(a)[prop] === Object(b)[prop]) - 1
          );
        });
      } else {
        mapped = pesqEntregas.sort((a, b) => {
          return (
            +(Object(a)[prop] < Object(b)[prop]) ||
            +(Object(a)[prop] === Object(b)[prop]) - 1
          );
        });
      }
      setSort({ ...sort, cres: auxCres });
    } else {
      mapped = pesqEntregas.sort((a, b) => {
        return (
          +(Object(a)[prop] > Object(b)[prop]) ||
          +(Object(a)[prop] === Object(b)[prop]) - 1
        );
      });
      setSort({ por: prop, cres: true });
    }

    // setSort({ por: prop, cres: !sort.cres });

    handleUpdateList(1, controls.perPage, mapped);
  }

  return (
		<Table 
			variant="striped"
			colorScheme="blackAlpha"
			size="sm"
			w="100%"
		>
      <Thead>
				<Tr>
          <Th cursor="pointer" onClick={() => handleSort('id_venda')}>
						<Flex fontSize={12}>
              COD. VENDA
              {sort.por === 'id_venda' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'id_venda' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

          <Th cursor="pointer" onClick={() => handleSort('nome_entregador')}>
						<Flex fontSize={12}>
              ENTREGADOR
              {sort.por === 'nome_entregador' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'nome_entregador' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

          <Th cursor="pointer" onClick={() => handleSort('data_entrega')}>
						<Flex fontSize={12}>
              ENTREGA
              {sort.por === 'data_entrega' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'data_entrega' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

					<Th cursor="pointer" onClick={() => handleSort('data_previsao')}>
						<Flex fontSize={12}>
							PREVISÃO
							{sort.por === 'data_previsao' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'data_previsao' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('tempo')}>
						<Flex fontSize={12}>
							TEMPO
							{sort.por === 'tempo' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize={20} />
							) : (
								sort.por === 'tempo' &&
									!sort.cres && <Icon as={MdArrowDropDown} fontSize={20} />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('nome_cliente')}>
						<Flex fontSize={12}>
							CLIENTE
							{sort.por === 'nome_cliente' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'nome_cliente' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('pago')}>
						<Flex fontSize={12}>
							PAGO
							{sort.por === 'pago' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'pago' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('vlr_custo')}>
						<Flex justify="flex-end" fontSize={12}>
							V. CUSTO
							{sort.por === 'vlr_custo' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'vlr_custo' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('vlr_troco')}>
						<Flex justify="flex-end" fontSize={12}>
							VLR. TROCO
							{sort.por === 'vlr_troco' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'vlr_troco' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('vlr_entrega')}>
						<Flex justify="flex-end" fontSize={12}>
							VLR. ENTREGA
							{sort.por === 'vlr_entrega' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'vlr_entrega' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th></Th>
        </Tr>
      </Thead>

      <Tbody>
				{entregas.map(entrega => {
          return (
						<Tr key={entrega.id_entrega} color="gray.700" fontSize={14}>
              <Td cursor="pointer">
                <Flex>
                  <Text color="#1a83ff" fontWeight="bold">
										{entrega.id_venda}
                  </Text>
									{entrega.tipo_venda === 'IFood' ? (
										<Icon as={SiIfood} ml={2} color="#c53030" />
									) : (
										<Icon as={FaStore} ml={2} color="#1a83ff" />
									)}
                </Flex>
              </Td>
							<Td>
								{entrega.nome_entregador}
              </Td>
							<Td>
								{entrega.data_entrega}
              </Td>
							<Td>
								{entrega.data_previsao}
							</Td>
							<Td>
								<Flex>
									<Icon
										as={MdTimer}
										color={entrega.atraso === 'Sim' ? '#c53030' : '#1B5E20'}
										fontSize={20}
										mr={1}
									/>
									{entrega.tempo}
								</Flex>
							</Td>
							<Td>
								{entrega.nome_cliente}
							</Td>
							<Td>
								{entrega.pago === 'N' ? (
									<Icon as={MdMoneyOff} color="#c53030" fontSize={20} />
								) : (
									<Icon as={MdAttachMoney} color="#1B5E20" fontSize={20} />
								)}
							</Td>
							<Td isNumeric>{entrega.vlr_custoFormatted}</Td>
							<Td isNumeric>{entrega.vlr_trocoFormatted}</Td>
							<Td isNumeric>{entrega.vlr_entregaFormatted}</Td>
							<Td>
								<Menu>
									{({ isOpen }) => (
										<>
											<MenuButton
												border={0}
												fontSize="1.5626rem"
												as={IconButton}
												isActive={isOpen}
												aria-label="Options"
												icon={<FiMoreVertical />}
												variant="outline"
												_hover={{
													bg: 'gray.50'
												}}
											/>

											<MenuList p={0} boxShadow='xl'>
												<MenuItem
													fontSize={16}
													fontWeight={500}
													py={3}
													_hover={{
														bg: 'gray.50'
													}}
													onClick={() => {
														setEntregaModal(entrega);
														setModalEntregaVisible(true);
													}}
												>
													Detalhes
												</MenuItem>

												{permissions.alterar && (
													<>
														<Divider />

														<MenuItem 
															fontSize={16}
															fontWeight={500}
															py={3}
															_hover={{
																bg: 'gray.50'
															}}
														isDisabled={true}>
															Editar
														</MenuItem>
													</>
												)}
											</MenuList>
										</>
									)}
								</Menu>
							</Td>
            </Tr>
          );
        })}
      </Tbody>

			<Tfoot>
				<Tr>
					<Th paddingTop={4} fontSize={16}>Totais</Th>
					<Th></Th>
					<Th></Th>
					<Th></Th>
					<Th></Th>
					<Th></Th>
					<Th></Th>
					<Th isNumeric paddingTop={4} fontSize={16} >{totals.custo}</Th>
					<Th isNumeric paddingTop={4} fontSize={16}>{totals.troco}</Th>
					<Th isNumeric paddingTop={4} fontSize={16}>{totals.entrega}</Th>
					<Th></Th>
				</Tr>
			</Tfoot>
    </Table>
  );
};

export default DataTableTable;
